import { cn } from "@/lib/utils";
import { type ComponentProps, splitProps } from "solid-js";

export function PositiveTractionIcon(props: ComponentProps<"svg">) {
  const [local, rest] = splitProps(props, ["class", "style"]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 800"
      class={local.class}
      {...rest}
    >
      <title>Positive Traction</title>
      <path
        id="2"
        class="fill fill-primary"
        d="M298.681 722.286v-75.413l.001-.014v-32.52c0-11.938-18.553-11.958-18.553 0v.001h-.001v107.946a7.109 7.109 0 0 1-7.102 7.102h-46.632a7.11 7.11 0 0 1-7.102-7.102V447.461a7.109 7.109 0 0 1 7.102-7.102h46.632a7.11 7.11 0 0 1 7.102 7.102v110.593h.001v.001c0 11.938 18.553 11.958 18.553 0v-32.521l-.001-.014v-78.059c0-14.146-11.51-25.655-25.655-25.655h-46.632c-14.146 0-25.655 11.51-25.655 25.655v274.826c0 14.146 11.51 25.655 25.655 25.655h46.632c14.145 0 25.655-11.51 25.655-25.656z"
      />
      <path
        id="4"
        class="fill fill-primary"
        d="M289.405 576.196a8.677 8.677 0 1 0 0 17.354 8.677 8.677 0 0 0 0-17.354zM591.026 558.054l.001-110.593c0-14.146-11.51-25.655-25.655-25.655H518.74c-14.15 0-25.66 11.51-25.66 25.655v274.826c0 14.146 11.51 25.655 25.66 25.655h46.632c14.146 0 25.655-11.51 25.655-25.655V614.34h-.001v-.001c0-11.938-18.553-11.958-18.553 0v32.52l.001.006v75.421a7.109 7.109 0 0 1-7.102 7.102H518.74c-3.918 0-7.107-3.187-7.107-7.102V447.461c0-3.916 3.189-7.102 7.107-7.102h46.632a7.11 7.11 0 0 1 7.102 7.102v78.068l-.001.006v32.521c0 11.937 18.553 11.957 18.553-.002 0 .001 0 0 0 0z"
      />
      <path
        id="1-3-5"
        class="fill-primary"
        d="M126.617 485.072H76.421c-13.163 0-23.871 10.71-23.871 23.875v215.122c0 13.163 10.708 23.873 23.871 23.873h50.196c13.163 0 23.875-10.71 23.875-23.873V508.947c0-13.165-10.712-23.875-23.875-23.875zm5.322 238.997c0 2.883-2.437 5.32-5.322 5.32H76.421c-2.881 0-5.318-2.437-5.318-5.32V508.947c0-2.885 2.437-5.322 5.318-5.322h50.196c2.885 0 5.322 2.437 5.322 5.322v215.122zM420.199 747.942c13.24 0 24.011-10.771 24.011-24.009V315.968c0-13.238-10.771-24.009-24.011-24.009h-49.925c-13.235 0-24.007 10.771-24.007 24.009v407.965c0 13.238 10.771 24.009 24.007 24.009h49.925zm-55.378-24.009V315.968c0-2.958 2.496-5.456 5.454-5.456H420.2c2.958 0 5.458 2.498 5.458 5.456v407.965c0 2.958-2.5 5.456-5.458 5.456h-49.925c-2.958 0-5.454-2.498-5.454-5.456zM722.945 262.123h-48.937c-13.512 0-24.505 10.991-24.505 24.503V723.44c0 13.512 10.993 24.503 24.505 24.503h48.937c13.512 0 24.505-10.991 24.505-24.503V286.625c0-13.511-10.993-24.502-24.505-24.502zm5.952 461.316c0 3.225-2.727 5.95-5.952 5.95h-48.937c-3.225 0-5.952-2.725-5.952-5.95V286.625c0-3.225 2.727-5.949 5.952-5.949h48.937c3.225 0 5.952 2.724 5.952 5.949v436.814z"
      />
      <path
        id="fill-1"
        class="fill-primary/60"
        d="M131.939 724.069c0 2.883-2.437 5.32-5.322 5.32H76.421c-2.881 0-5.318-2.437-5.318-5.32V508.947c0-2.885 2.437-5.322 5.318-5.322h50.196c2.885 0 5.322 2.437 5.322 5.322v215.122z"
      />
      <path
        id="fill-3"
        class="fill-primary/80"
        d="M364.821 723.933V315.968c0-2.958 2.496-5.456 5.454-5.456H420.2c2.958 0 5.458 2.498 5.458 5.456v407.965c0 2.958-2.5 5.456-5.458 5.456h-49.925c-2.958 0-5.454-2.498-5.454-5.456z"
      />
      <path
        id="fill-5"
        class="fill-primary/100"
        d="M728.897 723.439c0 3.225-2.727 5.95-5.952 5.95h-48.937c-3.225 0-5.952-2.725-5.952-5.95V286.625c0-3.225 2.727-5.949 5.952-5.949h48.937c3.225 0 5.952 2.724 5.952 5.949v436.814z"
      />
    </svg>
  );
}

export function PositiveTractionLogo(props: ComponentProps<"svg">) {
  const [local, rest] = splitProps(props, ["class", "style"]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      viewBox="0 0 400 400"
      class={cn(
        "h-full w-full",
        "[clip-rule:evenodd] [fill-rule:evenodd] [stroke-linejoin:round] [stroke-miterlimit:2]",
        local.class,
      )}
      {...rest}
    >
      <title>Positive Traction</title>
      <g id="Logo">
        <path
          id="Block-1-1"
          d="M22.46,46.404c-0,-9.634 7.829,-17.48 17.497,-17.48l61.361,-0c9.668,-0 17.497,7.846 17.497,17.48l-0,61.394c-0,9.634 -7.829,17.446 -17.497,17.446l-61.361,0c-9.668,0 -17.497,-7.812 -17.497,-17.446l-0,-61.394Z"
          class={cn(
            "fill-azul transition-all duration-300 [fill-rule:nonzero] group-hover:fill-azul/80",
            "group-hover:-translate-x-5 group-hover:-translate-y-5 group-hover:scale-105 group-hover:animate-shake",
          )}
        />
        <path
          id="Block-2-1"
          d="M151.829,46.404c0,-9.634 7.835,-17.48 17.498,-17.48l61.343,-0c9.668,-0 17.497,7.846 17.497,17.48l0,61.394c0,9.634 -7.829,17.446 -17.497,17.446l-61.343,0c-9.663,0 -17.498,-7.812 -17.498,-17.446l0,-61.394Z"
          class={cn(
            "fill-cinnabar transition-all duration-300 [fill-rule:nonzero] group-hover:fill-cinnabar/80",
            "group-hover:-translate-y-5 group-hover:scale-105 group-hover:animate-shake",
          )}
        />
        <path
          id="Block-1-2"
          d="M22.46,169.301c-0,-9.668 7.829,-17.486 17.497,-17.486l61.361,0c9.668,0 17.497,7.818 17.497,17.486l-0,61.355c-0,9.702 -7.829,17.52 -17.497,17.52l-61.361,-0c-9.668,-0 -17.497,-7.818 -17.497,-17.52l-0,-61.355Z"
          class={cn(
            "fill-azul transition-all duration-300 [fill-rule:nonzero] group-hover:fill-azul/80",
            "group-hover:-translate-x-5 group-hover:scale-105 group-hover:animate-shake",
          )}
        />
        <path
          id="Block-2-2" // middle
          d="M151.829,169.301c0,-9.668 7.835,-17.486 17.498,-17.486l61.343,0c9.668,0 17.497,7.818 17.497,17.486l0,61.355c0,9.702 -7.829,17.52 -17.497,17.52l-61.343,-0c-9.663,-0 -17.498,-7.818 -17.498,-17.52l0,-61.355Z"
          class={cn(
            "fill-cinnabar transition-all duration-300 [fill-rule:nonzero] group-hover:fill-cinnabar/80",
            "group-hover:scale-105 group-hover:animate-shake",
          )}
        />
        <path
          id="Block-3-2"
          d="M281.185,169.301c0,-9.668 7.835,-17.486 17.497,-17.486l61.361,0c9.668,0 17.497,7.818 17.497,17.486l-0,61.355c-0,9.702 -7.829,17.52 -17.497,17.52l-61.361,-0c-9.662,-0 -17.497,-7.818 -17.497,-17.52l0,-61.355Z"
          class={cn(
            "fill-azul transition-all duration-300 [fill-rule:nonzero] group-hover:fill-azul/80",
            "group-hover:translate-x-5 group-hover:scale-105 group-hover:animate-shake",
          )}
        />
        <path
          id="Block-1-3"
          d="M22.46,292.196c-0,-9.668 7.829,-17.48 17.497,-17.48l61.361,-0c9.668,-0 17.497,7.812 17.497,17.48l-0,61.395c-0,9.633 -7.829,17.485 -17.497,17.485l-61.361,0c-9.668,0 -17.497,-7.852 -17.497,-17.485l-0,-61.395Z"
          class={cn(
            "fill-cinnabar transition-all duration-300 [fill-rule:nonzero] group-hover:fill-cinnabar/80",
            "group-hover:-translate-x-5 group-hover:translate-y-5 group-hover:scale-105 group-hover:animate-shake",
          )}
        />
        <path
          id="Block-2-3"
          d="M151.829,292.196c0,-9.668 7.835,-17.48 17.498,-17.48l61.343,-0c9.668,-0 17.497,7.812 17.497,17.48l0,61.395c0,9.633 -7.829,17.485 -17.497,17.485l-61.343,0c-9.663,0 -17.498,-7.852 -17.498,-17.485l0,-61.395Z"
          class={cn(
            "fill-azul transition-all duration-300 [fill-rule:nonzero] group-hover:fill-azul/80",
            "group-hover:translate-y-5 group-hover:scale-105 group-hover:animate-shake",
          )}
        />
        <path
          id="Block-3-3"
          d="M281.185,292.196c0,-9.668 7.835,-17.48 17.497,-17.48l61.361,-0c9.668,-0 17.497,7.812 17.497,17.48l-0,61.395c-0,9.633 -7.829,17.485 -17.497,17.485l-61.361,0c-9.662,0 -17.497,-7.852 -17.497,-17.485l0,-61.395Z"
          class={cn(
            "fill-cinnabar transition-all duration-300 [fill-rule:nonzero] group-hover:fill-cinnabar/80",
            "group-hover:translate-x-5 group-hover:translate-y-5 group-hover:scale-105 group-hover:animate-shake",
          )}
        />
      </g>
    </svg>
  );
}

/**
 *
      <circle
        class="fill-primary-foreground"
        transform="rotate(-89.089 109.842 374.376)"
        cx="109.849"
        cy="374.388"
        r="20.193"
      />
      <path
        class="fill-primary"
        d="M250.509 257.485c-11.138 0-20.197-9.059-20.197-20.195 0-11.134 9.059-20.193 20.197-20.193 11.134 0 20.193 9.059 20.193 20.193 0 11.136-9.059 20.195-20.193 20.195z"
      />
      <path
        class="fill-primary"
        d="M394.499 165.605c-11.138 0-20.197-9.059-20.197-20.193 0-11.136 9.059-20.195 20.197-20.195 11.134 0 20.193 9.059 20.193 20.195 0 11.134-9.06 20.193-20.193 20.193z"
      />
      <path
        class="fill-primary"
        d="M543.127 257.485c-11.134 0-20.193-9.059-20.193-20.195 0-11.134 9.059-20.193 20.193-20.193 11.134 0 20.193 9.059 20.193 20.193 0 11.136-9.06 20.195-20.193 20.195z"
      />
      <path
        class="fill-primary"
        d="M697.738 70.611c11.134 0 20.193 9.059 20.193 20.195 0 11.134-9.059 20.193-20.193 20.193-11.138 0-20.197-9.059-20.197-20.193 0-11.135 9.059-20.195 20.197-20.195z"
      />
 *
 */
